import React from "react";
import { Text, Flex, Box, Divider } from "@chakra-ui/react";

import { IconBackgroundContainer, TextPrimary, TextSecondary } from "theme";
import { DocumentLegalLowHammer, ThumpsUpCircle, Success } from "icons";

import Icon from "../../components/Icon";
import FooterButtons from "../SuccessErrorModalBodyTemplate/components/FooterButtons";

import { TransactionType } from "../../constants/common";
import { SD } from "../../constants/constants";

interface ConfirmationBodyTemplateProps {
  modalTitle: string;
  token: string;
  modalSubTitle?: string;
  primaryBtnTxt?: string; // view transactions
  secondaryBtnTxt?: string; // close or cancel
  onSubmitPrimary?: () => void;
  onSubmitSecondary?: () => void;
  transactionType?: TransactionType;
}

export const TransactionIconMapping: any = {
  [TransactionType.SUCCESS]: {
    icon: "/transaction/success.svg",
  },
};

const TEMPLATE_DATA = [
  {
    icon: DocumentLegalLowHammer,
    title: "Governance",
  },
  {
    icon: ThumpsUpCircle,
    title: "Staking rewards",
  },
];

const ConfirmationBodyTemplate = ({
  modalTitle,
  modalSubTitle,
  primaryBtnTxt,
  secondaryBtnTxt,
  token,
  onSubmitPrimary,
  onSubmitSecondary,
  transactionType,
}: ConfirmationBodyTemplateProps) => {
  return (
    <>
      {transactionType && (
        <Box mb="1rem" height="48px">
          <Icon Icon={Success} width="48px" height="48px" />
        </Box>
      )}
      <Text
        // mt={{ base: "0", md: "2rem" }}
        fontWeight="600"
        fontSize={{
          base: "20px",
          md: "24px",
        }}
        lineHeight={{ base: "24px", md: "28px" }}
      >
        {modalTitle}
      </Text>

      {token === SD ? (
        <>
          {modalSubTitle && (
            <TextSecondary
              mt="0.5rem"
              fontSize={{
                base: "12px",
                md: "14px",
              }}
              fontWeight="400"
              textAlign="center"
              lineHeight={{ base: "18px", md: "20px" }}
            >
              {modalSubTitle}
            </TextSecondary>
          )}
          <Flex
            p={{ base: "0 32px", md: "0 80px" }}
            alignItems={{ base: "flex-start", md: "center" }}
            mt="1.5rem"
            width="100%"
            justifyContent="center"
            flexDirection={{ base: "column", md: "row" }}
          >
            {TEMPLATE_DATA.map((data, index) => (
              <Flex
                ml={{ base: "0", md: index > 0 ? "40px" : 0 }}
                mt={{ base: index > 0 ? "1.5rem" : 0, md: 0 }}
                flexDir={{ base: "row", md: "column" }}
                key={data.title}
                alignItems="center"
              >
                <IconBackgroundContainer>
                  <Box
                    w={{ base: "16px", lg: "24px" }}
                    h={{ base: "16px", lg: "24px" }}
                  >
                    <Icon
                      width="100%"
                      height="100%"
                      color="textPrimary"
                      Icon={data.icon}
                    />
                  </Box>
                </IconBackgroundContainer>
                <TextPrimary
                  mt={{ base: "0", md: "0.5rem" }}
                  ml={{ base: "12px", md: 0 }}
                  fontWeight="600"
                  fontSize="14px"
                  lineHeight="20px"
                >
                  {data.title}
                </TextPrimary>
              </Flex>
            ))}
          </Flex>

          {primaryBtnTxt && secondaryBtnTxt ? (
            <Divider color="seperator" mt="2rem" />
          ) : null}
        </>
      ) : null}

      {primaryBtnTxt || secondaryBtnTxt ? (
        <Box mt="1.5rem">
          <FooterButtons
            secondaryBtnTxt={secondaryBtnTxt}
            onSubmitSecondary={onSubmitSecondary}
            primaryBtnTxt={primaryBtnTxt}
            onSubmitPrimary={onSubmitPrimary}
          />
        </Box>
      ) : null}
    </>
  );
};

export default ConfirmationBodyTemplate;
